import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Pagination } from '../../../interfaces/pagination';

import { User } from '../../../models/db/user';
import { LoginService } from '../../../services/login/login.service';
import { UserService } from '../../../services/user/user.service';
// import { Auth } from '../interfaces/routes/interfaces';



export const useUser = () => {


    const register = (user: User) => {
        return new Promise<any>((res, rej) => {
            LoginService.register(user)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }


    const autocompleteUserBack = (query: string, itemsPerPage: number, field: string) => {
        return new Promise<any>((res, rej) => {
            UserService.autocompleteBack(query, itemsPerPage, field)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    rej(e)
                })

        })
    }


    const getUserById = (id) => {
        return new Promise<any>((res, rej) => {
            UserService.get(id)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }



    const getUser = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((res, rej) => {
            UserService.getAll(pagination)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {

                    console.log(e)
                    rej(e)
                })

        })
    }




    const addUser = (user: User) => {
        return new Promise<any>((res, rej) => {
            UserService.add({ ...user })
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }


    const updateUser = (user: User, myId: string) => {
        return new Promise<any>((res, rej) => {
            UserService.update({ ...user }, myId)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }

    const updatePassword = (id: string, password: string, myId: string) => {
        return new Promise<any>((res, rej) => {
            UserService.updatePassword(id, password, myId)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }


    const deleteUser = (idList: string[] | number[], action: boolean) => {
        return new Promise<any>((res, rej) => {
            UserService.delete(idList, action)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }

    const checkAdmin = () => {
        return new Promise<any>((res, rej) => {
            UserService.checkAdmin()
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }

    const checkPassword = (id: any, password: any) => {
        return new Promise<any>((res, rej) => {
            UserService.checkPassword(id, password)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }

    const checkUsername = (id: any, username: string) => {
        return new Promise<any>((res, rej) => {
            console.log(id, username)
            UserService.checkUsername(id, username)
                .then(({ data }) => {
                    // console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }


    const checkPasswordPublic = (id: any, password: any) => {
        return new Promise<any>((res, rej) => {
            UserService.checkPasswordPublic(id, password)
                .then(({ data }) => {
                    console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }

    const checkUsernamePublic = (id: any, username: string) => {
        return new Promise<any>((res, rej) => {
            UserService.checkUsernamePublic(id, username)
                .then(({ data }) => {
                    // console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }


    const getUserList = (idUserList: string[]) => {
        return new Promise<any>((res, rej) => {
            UserService.getUserList(idUserList)
                .then((item) => {
                    if (item && item.data && item.data?.ok) {
                        res(item.data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })
        })
    }

    return {
        register,
        autocompleteUserBack,
        // getAllIdUser,
        getUserById,
        getUser,
        getUserList,
        addUser,
        updateUser,
        deleteUser,
        checkAdmin,
        checkPassword,
        checkUsername,
        checkPasswordPublic,
        checkUsernamePublic,

        // Additional function aliases for convenience
        getById: getUserById,
        get: getUser,
        add: addUser,
        update: updateUser,
        delete: deleteUser,
        autocomplete: getUser,
        autocompleteBack: autocompleteUserBack,
        updatePassword,
    }
}